import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import HomePage from './pages/Home'
import KnowledgeBase from './pages/KnowledgeBase'
import KnowledgeBaseManagement from './pages/KnowledgeBaseManagement'
import PDFUpload from './pages/PDFUpload'
import ErrorBoundary from './components/common/ErrorBoundary'
import './styles/index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ErrorBoundary>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/knowledge-base/:id" element={<KnowledgeBase />} />
                    <Route path="/upload" element={<PDFUpload />} />
                    <Route path="/upload/:knowledgeBaseId" element={<PDFUpload />} />
                    <Route path="/knowledge-bases" element={<KnowledgeBaseManagement />} />
                    <Route path="/create-knowledge-base" element={<KnowledgeBaseManagement />} />
                    <Route path="/manage/:id" element={<div>管理知识库页面 - 待实现</div>} />
                    <Route path="/search" element={<div>搜索页面 - 待实现</div>} />
                    <Route path="/analytics" element={<div>学习分析页面 - 待实现</div>} />
                </Routes>
            </BrowserRouter>
        </ErrorBoundary>
    </React.StrictMode>,
)
